export const detectPhrases = (text: string) => (/"(?:.*)[^"]*?"/i).test(text);
